// @ts-ignore
/* eslint-disable */
import request from '../request';

/** callback GET /api/auth/callback */
export async function callbackUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.callbackUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<string>('/api/auth/callback', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
